import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "attachment-preview" }

import type { Attachment } from "@/dtos/Unipile.dto";
import ImageAttachment from "./attachments/ImageAttachment.vue";
import VideoAttachment from "./attachments/VideoAttachment.vue";
import AudioAttachment from "./attachments/AudioAttachment.vue";
import FileAttachment from "./attachments/FileAttachment.vue";
import LinkAttachment from "./attachments/LinkAttachment.vue";
import LinkedInPostAttachment from "./attachments/LinkedInPostAttachment.vue";
import VideoMeetingAttachment from "./attachments/VideoMeetingAttachment.vue";

interface Props {
  attachment: Attachment;
  messageId?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AttachmentPreview',
  props: {
    attachment: {},
    messageId: {}
  },
  emits: ["imageClick"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.attachment.type === 'img')
      ? (_openBlock(), _createBlock(ImageAttachment, {
          key: 0,
          attachment: __props.attachment,
          "message-id": __props.messageId,
          onImageClick: _cache[0] || (_cache[0] = (url, att) => _ctx.$emit('imageClick', url, att))
        }, null, 8, ["attachment", "message-id"]))
      : (__props.attachment.type === 'video')
        ? (_openBlock(), _createBlock(VideoAttachment, {
            key: 1,
            attachment: __props.attachment,
            "message-id": __props.messageId
          }, null, 8, ["attachment", "message-id"]))
        : (__props.attachment.type === 'audio')
          ? (_openBlock(), _createBlock(AudioAttachment, {
              key: 2,
              attachment: __props.attachment,
              "message-id": __props.messageId
            }, null, 8, ["attachment", "message-id"]))
          : (__props.attachment.type === 'file')
            ? (_openBlock(), _createBlock(FileAttachment, {
                key: 3,
                attachment: __props.attachment,
                "message-id": __props.messageId
              }, null, 8, ["attachment", "message-id"]))
            : (__props.attachment.type === 'link')
              ? (_openBlock(), _createBlock(LinkAttachment, {
                  key: 4,
                  attachment: __props.attachment
                }, null, 8, ["attachment"]))
              : (__props.attachment.type === 'linkedin_post')
                ? (_openBlock(), _createBlock(LinkedInPostAttachment, {
                    key: 5,
                    attachment: __props.attachment
                  }, null, 8, ["attachment"]))
                : (__props.attachment.type === 'video_meeting')
                  ? (_openBlock(), _createBlock(VideoMeetingAttachment, {
                      key: 6,
                      attachment: __props.attachment
                    }, null, 8, ["attachment"]))
                  : _createCommentVNode("", true)
  ]))
}
}

})